
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Innovacarrentalinpune() {



    const cardData =
    {
        keyword: 'Innova Car Rental In Pune',
        heading: 'Meghana Cab : Innova Car Rental In Pune',
        headingDescription: 'Meghana Cab offers Innova Car Rental in Pune, delivering a premium, spacious, and versatile travel solution for any occasion—from city commutes and airport transfers to hill-station trips and corporate outings. Our Innova vehicles are well-maintained and feature air-conditioning, ample legroom, generous luggage space, and professional chauffeurs to ensure a comfortable and elegant ride.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Aga Khan Palace",
    "description": "This majestic palace was built in 1892 by Sultan Aga Khan III and holds a revered place in India’s freedom struggle. It served as a place of incarceration for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. The palace, surrounded by serene gardens, now functions as a memorial and museum, housing Gandhi’s belongings, rare photographs, and his ashes. It is a peaceful oasis that blends architecture, history, and patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 35 km southwest of Pune, Sinhagad Fort is a hilltop military outpost famed for the 1670 Battle of Sinhagad, where Maratha warrior Tanaji Malusare displayed unparalleled bravery. Trekkers flock to this fort year-round for its rugged paths, panoramic views, and rustic food stalls serving local delicacies like 'pithla-bhakri'. The ruins of gates, watchtowers, and memorials transport visitors back to the era of valor and strategy. Monsoon is an especially magical time to visit."
  },
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is an iconic symbol of Pune’s Maratha legacy. Once a grand palace complex with seven stories and ornate halls, it was tragically gutted by a fire in 1828. Today, its massive gates, fortified walls, lotus-shaped fountains, and sprawling gardens continue to attract history lovers. Legends of palace intrigue and haunting folklore make it one of Pune’s most visited historical sites. The evening light-and-sound show offers a captivating audio-visual journey into Maratha history."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Spread across 28 acres in Koregaon Park, the Osho Ashram is one of the world’s largest meditation centers. It blends Zen-inspired architecture with lush gardens and modern amenities. The resort offers dynamic meditations, healing therapies, creative workshops, and wellness programs. Visitors from over 100 countries come here for personal transformation, silence, and rejuvenation. It’s a unique sanctuary where mindfulness meets luxury, nestled within Pune’s urban heart."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "Dedicated to Lord Ganesha, this 130-year-old temple is a spiritual landmark in Pune’s Budhwar Peth area. The temple’s 7.5-foot-tall idol is adorned with over 40 kg of gold and is revered by politicians, celebrities, and millions of devotees. It becomes the epicenter of the city’s Ganesh Chaturthi celebrations, drawing lakhs of people. The temple is known for its vibrant atmosphere, intricate decorations, and a strong connection to Pune’s cultural identity."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, Pataleshwar is carved from a single basalt rock and features a sanctum with a Shiva lingam, a circular Nandi mandapa, and intricately carved pillars. Located on busy Jangli Maharaj Road, this monument offers a peaceful spiritual retreat amidst urban life. It stands as a testament to ancient Indian architecture and artistry and is a lesser-known gem in Pune’s heritage circuit."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This unique museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing the everyday life of India’s past. From ornate doors and miniature paintings to musical instruments, sculptures, and antique utensils, the exhibits reflect the richness of Indian craftsmanship. The highlight is the reconstructed 'Mastani Mahal', representing the royal elegance of the Maratha court. Audio guides and themed galleries make this a must-visit cultural destination."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Rising 2,100 feet above sea level, Parvati Hill offers a scenic trek with 103 stone steps leading to a hilltop complex of Peshwa-era temples. The Parvati Temple, dedicated to Goddess Parvati, offers panoramic views of Pune. A small museum here showcases artifacts from the Peshwa dynasty. The spot is perfect for early morning visits, photography, and spiritual reflection—especially during sunrise and winter months."
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Spread across 130 acres on the southern outskirts of Pune, this well-maintained zoological park includes a snake park, zoo, and lake. It houses tigers, leopards, elephants, deer, crocodiles, and a wide variety of birds. It’s an educational hotspot for children and families, offering nature trails, animal adoption programs, and boating facilities. The zoo is a perfect mix of wildlife conservation and recreation."
  },
  {
    "title": "Shinde Chhatri",
    "description": "Located in Wanowrie, Shinde Chhatri is a stunning 18th-century memorial dedicated to Maratha military leader Mahadji Shinde. The structure features elaborate Rajasthani-style domes, colorful stained-glass windows, and an atmosphere of serene grandeur. The adjoining Shiva temple and the samadhi (final resting place) of Shinde add to the historical depth. It’s one of Pune’s lesser-known heritage sites, rich in architecture and historical importance."
  }
],

"services": [
  {
    "name": "Innova Car Rental Pune",
    "description": "Discover the convenience and luxury of Innova car rental in Pune. Whether for city travel, weekend getaways, or business trips, our fleet of well-maintained Innova cars ensures a smooth, comfortable ride with ample space and modern amenities."
  },
  {
    "name": "Rent Innova Car Pune",
    "description": "Rent an Innova car in Pune effortlessly with our flexible rental plans. Choose from hourly, daily, or long-term packages tailored to your travel needs. Our vehicles are equipped with AC, spacious interiors, and safety features for a premium travel experience."
  },
  {
    "name": "Chauffeur Driven Innova Car Rental Pune",
    "description": "Enjoy a hassle-free journey with our chauffeur-driven Innova car rental service in Pune. Our professional and courteous drivers prioritize your safety and comfort, making it ideal for corporate travel, family outings, and airport transfers."
  },
  {
    "name": "Affordable Innova Car Hire Pune",
    "description": "Get premium Innova car hire services in Pune without stretching your budget. Our affordable pricing packages make luxury travel accessible, whether for local commuting, outstation trips, or special occasions."
  },
  {
    "name": "Online Innova Car Rental Booking Pune",
    "description": "Book your Innova car rental online in Pune with ease and confidence. Our user-friendly platform provides instant confirmations, transparent pricing, and multiple payment options for a seamless booking experience."
  },
  {
    "name": "Corporate Innova Car Rental Pune",
    "description": "Enhance your business travel with our corporate Innova car rental services in Pune. Our fleet includes well-maintained vehicles with executive interiors, ideal for meetings, client visits, airport pickups, and corporate events."
  },
  {
    "name": "Family Innova Car Rental Pune",
    "description": "Plan a comfortable and spacious trip with your family using our Innova car rental services in Pune. Our vehicles accommodate larger groups with ease, providing plenty of luggage space and air conditioning for enjoyable family travel."
  },
  {
    "name": "Airport Transfer Innova Car Rental Pune",
    "description": "Make your airport transfers stress-free with our Innova car rental service in Pune. Available 24/7, we ensure timely pickups and drop-offs with professional drivers and comfortable rides, perfect for both solo travelers and groups."
  }
],
"tableData": [
  ["Innova Car Rental Pune", "Rent Innova Car Pune"],
  ["Chauffeur Driven Innova Car Rental Pune", "Affordable Innova Car Hire Pune"],
  ["Online Innova Car Rental Booking Pune", "Corporate Innova Car Rental Pune"],
  ["Family Innova Car Rental Pune", "Airport Transfer Innova Car Rental Pune"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Innova Car Rental in Pune",
        "WhyChoosedescription": "Rent an Innova or Innova Crysta in Pune for a smooth and comfortable journey—ideal for family trips, corporate travel, airport transfers, or outstation tours. Enjoy a premium travel experience with a vehicle known for its space, power, and comfort."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Interiors",
        "WhyChoosedescription": "The Innova offers plush seating, wide legroom, rear AC vents, and spacious boot space—perfect for long-distance rides or daily travel with groups. Accommodates up to 6–7 passengers comfortably, making it ideal for both short and extended journeys."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Fleet",
        "WhyChoosedescription": "Our Innova cars are kept in excellent condition with regular servicing and deep cleaning. Each vehicle is sanitized before every trip to ensure maximum hygiene and safety for all passengers."
    },
    {
        "WhyChooseheading": "Experienced and Polite Drivers",
        "WhyChoosedescription": "Our professional drivers are courteous, punctual, and knowledgeable about Pune city and surrounding routes. They prioritize your comfort and safety while delivering a seamless and pleasant travel experience."
    },
    {
        "WhyChooseheading": "Flexible Rental Plans – Hourly, Daily, and Outstation",
        "WhyChoosedescription": "Choose from a wide range of rental options including hourly packages for local travel, full-day city tours, and multi-day outstation trips. Customize your pickup/drop location and itinerary as needed."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "We offer fair and fixed pricing with no hidden charges. Rates include fuel, tolls, taxes, and driver allowances—giving you complete clarity and peace of mind during your trip."
    },
    {
        "WhyChooseheading": "Perfect for Business, Leisure, and Group Travel",
        "WhyChoosedescription": "Whether it’s a business meeting, a family vacation, a wedding function, or a pilgrimage trip, Innova rentals in Pune are the ideal solution for convenient and spacious travel."
    },
    {
        "WhyChooseheading": "24/7 Booking Assistance and Support",
        "WhyChoosedescription": "Book your Innova rental anytime online or by phone. Our support team is available 24/7 to assist with inquiries, modifications, or urgent travel needs—ensuring a hassle-free experience from start to finish."
    }
]




























    }

const faqData = [
    {
        question: "How can I rent an Innova car in Pune?",
        answer: "You can rent an Innova car by calling Meghana Cab at +91 9075462128 or booking online through our website for a hassle-free experience."
    },
    {
        question: "What are the types of rental services available for Innova in Pune?",
        answer: "We offer Innova rentals for local travel, airport transfers, outstation trips, corporate travel, and hourly rentals."
    },
    {
        question: "How many passengers can an Innova car accommodate?",
        answer: "An Innova car comfortably seats 6 to 7 passengers with ample luggage space."
    },
    {
        question: "Is the Innova car rental service available 24/7 in Pune?",
        answer: "Yes, our Innova rental service operates round the clock to suit your travel schedule."
    },
    {
        question: "Are the Innova cars well-maintained and sanitized?",
        answer: "Absolutely. All Innova cars are regularly serviced, cleaned, and sanitized before every rental for your safety."
    },
    {
        question: "What is included in the rental fare?",
        answer: "The rental fare includes driver charges, fuel, and tolls. Additional waiting or parking charges may apply."
    },
    {
        question: "Can I book an Innova car for a one-way trip or round trip?",
        answer: "Yes, we offer both one-way and round-trip rental options to cater to your travel needs."
    },
    {
        question: "Is it possible to rent an Innova car on an hourly basis?",
        answer: "Yes, hourly rentals are available for flexible usage within Pune city."
    },
    {
        question: "Do you provide airport pickup and drop services with Innova rental?",
        answer: "Yes, we offer reliable airport transfer services using Innova cars in Pune."
    },
    {
        question: "What payment methods do you accept for Innova car rentals?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Rohit Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Rented an Innova from Meghana Cab in Pune for a family trip. The car was very comfortable and the service excellent.”',
    },
    {
        name: 'Ms. Aarti Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Smooth booking process and a well-maintained Innova car. Driver was punctual and courteous. Highly recommended!”',
    },
];

















































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const innovaCarRentalPuneSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Innova Car Rental in Pune",
  "description": "Affordable and chauffeur-driven Innova car rental service in Pune. Perfect for corporate travel, family trips, airport transfers, and convenient online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Car Rental Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/innova-car-rental-pune"
  }
};







    return (
        <div>

<Helmet>
  <title>Innova Car Rental in Pune | Affordable Chauffeur Driven Service</title>
  <meta
    name="description"
    content="Rent affordable and chauffeur-driven Innova cars in Pune for corporate travel, family trips, and airport transfers. Easy online booking available."
  />
  <meta
    name="keywords"
    content="Innova Car Rental Pune, Rent Innova Car Pune, Chauffeur Driven Innova Car Rental Pune, Affordable Innova Car Hire Pune, Online Innova Car Rental Booking Pune, Corporate Innova Car Rental Pune, Family Innova Car Rental Pune, Airport Transfer Innova Car Rental Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(innovaCarRentalPuneSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/38.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacarrentalinpune;